import type { Interceptor } from 'api/requestUtils'

export default function browserErrorLogger(): Interceptor {
  return f => f.catch((error: any) => {
    if (error.status === 404) {
      // 404 errors happen routinely and aren't necessarily concerning
      console.debug('API Error', error)
    } else {
      console.error('API Error', error)
    }

    throw error
  })
}
